import { useTranslation } from 'react-i18next';

interface LogoProps {
    size?: 'sm' | 'md' | 'lg';
    showWordmark?: boolean;
    className?: string;
}

// EIT lockup. Mark "EIT" in Fraunces with a hand-tuned tracking; the long-form
// company name sits beneath in Manrope, small, all-caps, wide-tracked. The
// orange-red is reserved for the bar that sits between mark and name — never
// the wordmark itself, to keep the letters legible on small-screen contexts.
export default function Logo({ size = 'md', showWordmark = true, className = '' }: LogoProps) {
    const { t, i18n } = useTranslation();
    const sizes = {
        sm: { mark: 'text-2xl', bar: 'w-6 h-px', sub: 'text-[10px]' },
        md: { mark: 'text-3xl', bar: 'w-8 h-px', sub: 'text-[11px]' },
        lg: { mark: 'text-5xl', bar: 'w-10 h-px', sub: 'text-[12px]' },
    }[size];

    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <span
                className={`font-display ${sizes.mark} text-ink-on tracking-tight leading-none`}
                aria-hidden="true"
            >
                {t('brand.short')}
            </span>
            {showWordmark && (
                <span className="flex flex-col gap-1">
                    <span className={`${sizes.bar} bg-ember`} aria-hidden="true" />
                    <span className={`${sizes.sub} font-body uppercase tracking-widest2 text-ink-muted`}>
                        {i18n.language === 'ar' ? 'Owners' : 'Owners Portal'}
                    </span>
                </span>
            )}
        </div>
    );
}
